import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { passwordConfirm } from 'services/apiUsers';

const usePasswordConfirm = () => {
  const queryClient = useQueryClient();
    const navigate = useNavigate();

  const {isPending,isSuccess,data,mutate:changePassword} = useMutation({
    mutationFn: passwordConfirm,
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        navigate('/')
    },
    onError:(error)=>{
        console.log("Error occurred when updating Org status",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })
  return{isPending,isSuccess,changePassword,data}
}

export default usePasswordConfirm